import { gql } from 'apollo-boost';

export const GET_BY_NETWORK = gql`
query networkSites($network: String!) {
  networkSites(network: $network) {
        id
        site {
        id
        name
        publisherId
        services {
          name
          enabled
          }
        }
    }      
  }  
`;

export const ADD_EDIT_NETWORK_SITE = gql`
mutation createNetworkSite($network: String!, $site: [String!]!){
  createNetworkSite(input: {
    sites: $site,
    network: $network
  }) {
    site {
      domain
    }
    id
  }
}
`;